import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AnalyticsService } from '~/core/services/analytics.service';
import { CompanyStore } from '~/core/store/company.store';
import { EnvironmentService } from '~/core/services/environment.service';
import { StateMenu, StartMenu } from '~/core/constants/sport-display-enums';
import { UserStore } from '~/core/store/user.store';
import { AuthenticationService } from '~/core/services/authentication.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private auth = inject(AuthenticationService);
  private userStore = inject(UserStore);
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);
  private companyStore = inject(CompanyStore);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skip = request.headers.has('skipInterceptor');
    const headers = skip ? request.headers.delete('skipInterceptor') : request.headers;
    return next.handle(request.clone({ headers })).pipe(
      tap(
        (ev: HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (
              error.status === 401 &&
              error.error === 'Unauthorized' &&
              !skip &&
              (request.url.includes(EnvironmentService.backendURL) || request.url.includes(EnvironmentService.backendUserURL))
            ) {
              if (this.userStore.userSignal()) {
                this.analyticsService.tokenExpiredActionTracking(this.companyStore.companySignal(), this.userStore.userSignal());
              }

              this.userStore.setUser(null);
              this.userStore.setLoggedIn(false);
              this.userStore.setUser(null);
              this.userStore.setLoggedIn(false);
              const mainStart = this.companyStore.companySignal()?.menu?.main?.start || StateMenu.PRE_MATCH;
              const homePage = StartMenu[mainStart]?.toLowerCase();
              this.router.navigate([`/${homePage ? homePage : ''}`]);
            }
          }
        },
      ),
    );
  }
}
